import { updateConversationApiConversationsSessionIdPut } from "@noa/api-core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { reportError } from "../../typed-client";
import { ApiError } from "../../errors";
import { ConversationQueryKey } from "../../query-keys";

interface LikeConversationParams {
  sessionId: string;
  liked: boolean;
}

const likeConversationRequest = async ({ sessionId, liked }: LikeConversationParams) => {
  await updateConversationApiConversationsSessionIdPut({
    path: { session_id: sessionId },
    body: { liked },
    throwOnError: true,
  });
};

export const useLikeConversation = () => {
  const queryClient = useQueryClient();
  return useMutation<void, ApiError, LikeConversationParams>({
    mutationFn: likeConversationRequest,
    onError: reportError,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ConversationQueryKey.all });
    },
  });
};
